import PageShell from "@/components/PageShell";
import { AppsShowcase } from "@/components/landing/AppsShowcase";
import { FAQ } from "@/components/landing/FAQ";

export default function AppsPage() {
  return (
    <PageShell crumbs={[{ label: "Apps del club" }]}>
      <AppsShowcase />
      <FAQ />
    </PageShell>
  );
}
